import { ChatMessage, ChatConversation, DirectMessage } from '@/types/chat';

export const mockLeagueMessages: ChatMessage[] = [
  {
    id: 'lm1',
    senderId: 't2',
    senderName: 'Jake',
    content: 'Who else is targeting interception machines in the draft? 🎯',
    timestamp: new Date(Date.now() - 1000 * 60 * 5),
  },
  {
    id: 'lm2',
    senderId: 't3',
    senderName: 'Sarah',
    content: 'Already got my eye on a few QBs with fumble issues 😈',
    timestamp: new Date(Date.now() - 1000 * 60 * 4),
  },
  {
    id: 'lm3',
    senderId: 't1',
    senderName: 'You',
    content: "Don't sleep on the RBs with ball security problems!",
    timestamp: new Date(Date.now() - 1000 * 60 * 3),
  },
  {
    id: 'lm4',
    senderId: 'system',
    senderName: 'System',
    content: '💣 Mike just used a Bench Bomb sabotage on Sarah!',
    timestamp: new Date(Date.now() - 1000 * 60 * 2),
    isSystem: true,
  },
  {
    id: 'lm5',
    senderId: 't4',
    senderName: 'Mike',
    content: 'Sorry not sorry Sarah 😂',
    timestamp: new Date(Date.now() - 1000 * 60 * 1),
  },
  {
    id: 'lm6',
    senderId: 't3',
    senderName: 'Sarah',
    content: "You're going to regret that Mike... revenge is coming 🔥",
    timestamp: new Date(Date.now() - 1000 * 30),
  },
];

export const mockConversations: ChatConversation[] = [
  {
    id: 'conv1',
    participantId: 't2',
    participantName: 'Jake',
    lastMessage: 'Would you take a 2nd round pick for him?',
    lastMessageTime: new Date(Date.now() - 1000 * 60 * 10),
    unreadCount: 2,
  },
  {
    id: 'conv2',
    participantId: 't3',
    participantName: 'Sarah',
    lastMessage: 'Let me think about that trade offer...',
    lastMessageTime: new Date(Date.now() - 1000 * 60 * 45),
    unreadCount: 0,
  },
  {
    id: 'conv3',
    participantId: 't4',
    participantName: 'Mike',
    lastMessage: "I'll send you the counter offer tonight",
    lastMessageTime: new Date(Date.now() - 1000 * 60 * 60 * 2),
    unreadCount: 0,
  },
  {
    id: 'conv4',
    participantId: 't5',
    participantName: 'Alex',
    lastMessage: 'GG on that win last week',
    lastMessageTime: new Date(Date.now() - 1000 * 60 * 60 * 24),
    unreadCount: 0,
  },
];

export const mockDirectMessages: Record<string, DirectMessage[]> = {
  conv1: [
    {
      id: 'dm1-1',
      senderId: 't2',
      senderName: 'Jake',
      recipientId: 't1',
      recipientName: 'You',
      content: "Hey, I'm interested in your RB. What would it take?",
      timestamp: new Date(Date.now() - 1000 * 60 * 30),
    },
    {
      id: 'dm1-2',
      senderId: 't1',
      senderName: 'You',
      recipientId: 't2',
      recipientName: 'Jake',
      content: "Make me an offer I can't refuse 😏",
      timestamp: new Date(Date.now() - 1000 * 60 * 25),
    },
    {
      id: 'dm1-3',
      senderId: 't2',
      senderName: 'Jake',
      recipientId: 't1',
      recipientName: 'You',
      content: 'Would you take a 2nd round pick for him?',
      timestamp: new Date(Date.now() - 1000 * 60 * 10),
    },
  ],
  conv2: [
    {
      id: 'dm2-1',
      senderId: 't1',
      senderName: 'You',
      recipientId: 't3',
      recipientName: 'Sarah',
      content: 'What do you think about a 2-for-1 trade?',
      timestamp: new Date(Date.now() - 1000 * 60 * 60),
    },
    {
      id: 'dm2-2',
      senderId: 't3',
      senderName: 'Sarah',
      recipientId: 't1',
      recipientName: 'You',
      content: 'Let me think about that trade offer...',
      timestamp: new Date(Date.now() - 1000 * 60 * 45),
    },
  ],
  conv3: [
    {
      id: 'dm3-1',
      senderId: 't4',
      senderName: 'Mike',
      recipientId: 't1',
      recipientName: 'You',
      content: "I'll send you the counter offer tonight",
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2),
    },
  ],
  conv4: [
    {
      id: 'dm4-1',
      senderId: 't5',
      senderName: 'Alex',
      recipientId: 't1',
      recipientName: 'You',
      content: 'GG on that win last week',
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24),
    },
  ],
};

export const leagueMembers = [
  { id: 't1', name: 'You' },
  { id: 't2', name: 'Jake' },
  { id: 't3', name: 'Sarah' },
  { id: 't4', name: 'Mike' },
  { id: 't5', name: 'Alex' },
  { id: 't6', name: 'Emma' },
  { id: 't7', name: 'Chris' },
  { id: 't8', name: 'Lisa' },
  { id: 't9', name: 'David' },
  { id: 't10', name: 'Rachel' },
];
